import { useEffect, useState } from "react";
import DeliverySummaryModal from "./DeliverySummaryModal";
import { FaFilter } from "react-icons/fa6";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import SalesOrderDetails from "../../components/modals/SalesOrderDetails";

export default function OrderTracking() {
  const [orders, setOrders] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrderNumber, setSelectedOrderNumber] = useState<string | null>(
    null
  );
  const [showModal, setShowModal] = useState(false);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [filters, setFilters] = useState<string>("");
  const { token } = useAppSelector((store) => store.auth);
  const [orderNumber, setOrderNumber] = useState<any>(null);
  const [viewDetails, setViewDetails] = useState(false);
  const [allMinistries, setAllMinistries] = useState<any>([]);

  const getOrders = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/sales/orders`,
        {
          headers: {
            Authorization: token || "",
          },
        }
      );
      setOrders(response.data.data || []);
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadOrders = async () => {
      try {
        getOrders();
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, []);

  const handleViewDetails = (orderNumber: any) => {
    setOrderNumber(orderNumber);
    setViewDetails((prev) => !prev);
  };

  const handleTrackNow = (orderId: string) => {
    setSelectedOrderNumber(orderId);
    setShowModal(true);
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "approved":
        return "bg-green-100 text-green-800";
      case "pending":
        return "bg-purple-100 text-purple-800";
      case "cancel":
        return "bg-red-100 text-red-800";
      case "On Hold":
        return "bg-yellow-100 text-yellow-800";
      case "In Transit":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/onboardingCategories`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        const data = res.data.categories.filter(
          (item: any) => item.category.toLowerCase() === "oyo state government"
        );
        setAllMinistries(data[0].categoryType);
      } catch (error) {
        console.error("An error occurred: ", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="px-4 md:px-6">
      <section className="flex justify-between items-center mb-3">
        <h1 className="text-xl font-medium mb-6">Client's Orders</h1>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md hover:bg-gray-50 text-sm"
        >
          <FaFilter className="text-gray-500" />
          <span>Filters</span>
        </button>
      </section>
      {showFilters && (
        <div className="bg-white p-4 rounded-md border border-gray-200 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Ministry Filter */}
            <div>
              <label
                htmlFor="userType"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Ministries
              </label>
              <select
                id="userType"
                name="userType"
                value={filters}
                onChange={(e) => setFilters(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                <option value="">All Ministries</option>
                {allMinistries &&
                  allMinistries.map((state: any) => (
                    <option key={state._id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-600"></div>
        </div>
      ) : (
        <div className="bg-white rounded-md shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Client
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    E-mail
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Action 1
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Track
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {orders &&
                  orders.map((order: any) => (
                    <tr key={order._id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {order.name}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">
                          {order.email}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => handleViewDetails(order.orderNumber)}
                          className="text-green-600 hover:text-green-900"
                        >
                          View Details
                        </button>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClass(
                            order.status
                          )}`}
                        >
                          {order.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => handleTrackNow(order.orderNumber)}
                          className="text-green-600 hover:text-green-900"
                        >
                          Track Now
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {viewDetails && (
        <SalesOrderDetails
          orderNumber={orderNumber}
          onClose={() => setViewDetails(false)}
        />
      )}

      {showModal && selectedOrderNumber && (
        <DeliverySummaryModal
          trackingId={selectedOrderNumber}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
